import pageTitle from 'ember-page-title/helpers/page-title';
import { t } from 'ember-intl';

<template>
  {{pageTitle (t "forgiveness_estimator_0726.title")}}
  {{outlet}}
</template>
